<template>
  <div class="bg-[#FAFAFC] rounded-[4] py-[5] mt-[8] px-[12] w-[348]" v-if="fileUrl">
    <div class="flex justify-between">
      <div class="flex items-center"> 
        <i class="icon t-[theme] t-[14] mr-[4]">&#xe639;</i>
        <a :href="fileUrl" target="_blank" class="t-[13] t-[#333333] pl-[5] pr-[10]">{{ fileName }}</a>
        <i class="icon t-[13] rotating t-[#247FFF]" v-if="fileStatus == 1">&#xe735;</i>
        <i class="icon t-[13] t-[#19AB80]" v-if="fileStatus == 2">&#xe725;</i>
        <i class="icon t-[13] t-[#FFA530]" v-if="fileStatus == 3">&#xe60a;</i>
        <span class="t-[12] t-[#247FFF] pl-[3] " v-if="fileStatus == 1">文件校验中</span>
        <span class="t-[12] t-[#19AB80] pl-[3]" v-if="fileStatus == 2">校验通过 </span>
        <span class="t-[12] t-[#FFA530] pl-[3]" v-if="fileStatus == 3">校验不符</span>
      </div>
      <i class="icon" @click="clearFile">&#xe641;</i>
    </div>
    <div v-if="fileStatus == 3">
      <div class="bg-[#fff] flex py-[10] pr-[10]">
        <div class="w-[24] text-center leading-[18]">
          <i class="icon t-[12] t-[#FFA530]">&#xec72;</i>
        </div>
        <div class="flex-1 t-[12] t-[#606266] leading-[18]">
          文件或不符材料要求，建议核对，若无误可忽略提示。
        </div>
      </div>
      <!-- <div class="flex justify-end mt-[6] mb-[9]">
        <slot name="upload-button">
          <div @click="reUpload"
            class="ml-[auto] rounded-[4] leading-[15] t-[12] t-[#247FFF] cursor-pointer border-[1] border-[#247FFF] border-solid py-[6] px-[12] ">
            重新上传
          </div>
        </slot>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'dg-lawsuit-file-check',
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: '文件'
    },
    fileStatus: {
      type: [Number,String],
      default: 0 // 0: 未开始, 1: 校验中, 2: 校验成功, 3: 校验失败
    }
  },
  data() {
    return {}
  },
  methods: {
    clearFile() {
      this.$emit('clear-file')
    },
    reUpload() {
      this.$emit('re-upload')
    }
  },
  mounted() { },
  created() { },
}
</script>
<style scoped></style>
